type ApiErrorFields = Record<string, string>

interface ApiErrorOptions extends ErrorOptions {
  fields?: ApiErrorFields
  status?: number
}

export default class ApiError extends Error {
  fields?: ApiErrorFields
  status?: number
  constructor(message?: string, options?: ApiErrorOptions) {
    const { fields, status, ...otherOptions } = options || {}
    super(message, otherOptions)
    this.fields = fields
    this.status = status
  }
}
